import { render, staticRenderFns } from "./ResultPrimerSilicOne.vue?vue&type=template&id=2e71d990"
import script from "./ResultPrimerSilicOne.vue?vue&type=script&lang=js"
export * from "./ResultPrimerSilicOne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports